import axios from "axios";
import { I18n } from "react-redux-i18n";
import {
  MOST_SEARCHED_ADS_ATTEMPT,
  MOST_SEARCHED_ADS_SUCCESS,
  MOST_SEARCHED_ADS_FAILED,
} from "../types/mostSearchedAdsTypes";
import { config } from "../../config";

const url_api = config.api.godiway;

export function loading() {
  return { type: MOST_SEARCHED_ADS_ATTEMPT };
}

export function success(data) {
  return { type: MOST_SEARCHED_ADS_SUCCESS, data };
}

export function failed(error) {
  return { type: MOST_SEARCHED_ADS_FAILED, error };
}

export const loadList = (data) => async (dispatch, getState) => {
  if (getState().mostSearchedAds?.loaded) {
    return;
  }

  dispatch(loading());
  await axios
    .get(url_api + "goder/mostsearched", {
      params: {
        id: data.user_id,
        lang: I18n.t("locale"),
      },
      headers: { Authorization: `Bearer ${data.token}` },
    })
    .then((response) => {
      if (response.status < 300 && response.data.status === "Success") {
        dispatch(success(response.data.body));
      } else {
        dispatch(failed(response.data.body || "try_later"));
      }
    })
    .catch(() => {
      dispatch(failed("try_later"));
    });
};
